import React, {Component} from 'react'
import _ from 'lodash'
import {
  Typography,
  Button,
  Card,
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import {Mutation, Query} from 'react-apollo'
import {Redirect} from 'react-router-dom'
import {facebookService} from '../../../../facebook'
import {
  updateProjectLineCredential,
  getLineCredential,
} from '../../../../functions/project'
import {requireAuthAndProject} from '../../../../auth'
import {FusePageCarded} from '../../../../@fuse'
import ProjectMemberPage from './ProjectMemberPage'
import {
  CONNECT_TO_FACEBOOK_PAGE,
  DISCONNECT_TO_FACEBOOK_PAGE,
} from '../../../../graphql/mutation'
import {GET_PROJECT} from '../../../../graphql/query'
import {FACEBOOK_ENABLE} from '../../../../config'

class SettingsPage extends Component {
  state = {
    editing: false,
    lineChannelId: '',
    lineChannelSecret: '',
    lineChannelAccessToken: '',
    isLineCredentialSubmitting: false,
    isLineCredentialSubmitted: false,
    webhookURL: '',
    pages: null,
    selectedPageValue: '0',
  }

  handleDeepleFacebookConnect = refetch => {
    facebookService.deepleConnectLogin(
      _.get(this.props, 'project.projectId'),
      this.onGetAccessToken,
    )
  }

  handleDeepleFacebookDisconnect = async (disconnectFacebook, refetch) => {
    const projectId = _.get(this.props, 'project.projectId')
    await disconnectFacebook({
      variables: {
        projectId,
      },
    })
    refetch()
  }

  onGetAccessToken = async facebookResult => {
    facebookService.accessToken = facebookResult.authResponse.accessToken
    facebookService.accessToken = await facebookService.getLongLiveToken()
    const pages = await facebookService.getPageList()
    this.setState({
      pages,
    })
  }

  onPageConnect = async (connectFacebook, refetch) => {
    const {pages, selectedPageValue} = this.state
    const selectedPage = pages.data[+selectedPageValue]
    const projectId = _.get(this.props, 'project.id')
    await connectFacebook({
      variables: {
        projectId,
        pageDetail: {
          access_token: selectedPage.access_token,
          name: selectedPage.name,
          id: selectedPage.id,
        },
      },
    })
    await refetch()
  }

  handlePageRadioChange = e => {
    this.setState({
      selectedPageValue: e.target.value.toString(),
    })
  }

  handleDeepleLineConnect = async () => {
    this.setState({
      isLineCredentialSubmitting: true,
    })

    const projectId = _.get(this.props, 'project.id')
    await updateProjectLineCredential(projectId, {
      channelSecret: this.state.lineChannelSecret,
      channelId: this.state.lineChannelId,
      channelAccessToken: this.state.lineChannelAccessToken,
    })

    await this.fetchCredential()

    this.setState({
      isLineCredentialSubmitting: false,
      isLineCredentialSubmitted: true,
      editing: false,
    })
  }

  handleEditClick = () => {
    this.setState({
      isLineCredentialSubmitted: false,
      lineChannelId: '',
      lineChannelSecret: '',
      lineChannelAccessToken: '',
      editing: true,
    })
  }

  handleLineChannelIdInputChange = e => {
    this.setState({lineChannelId: e.target.value})
  }

  handleLineChannelSecretInputChange = e => {
    this.setState({lineChannelSecret: e.target.value})
  }

  handleLineChannelAccessTokenInputChange = e => {
    this.setState({lineChannelAccessToken: e.target.value})
  }

  componentDidMount() {
    this.fetchCredential()
  }

  async fetchCredential() {
    const {data} = await getLineCredential(this.props.project.id)
    if (
      data.channelId &&
      data.channelSecret &&
      data.channelAccessToken &&
      data.webhookURL
    ) {
      this.setState({
        isLineCredentialSubmitted: true,
        lineChannelId: data.channelId,
        lineChannelSecret: data.channelSecret,
        lineChannelAccessToken: data.channelAccessToken,
        webhookURL: data.webhookURL,
      })
    }
  }

  render() {
    if (this.props.project.role !== 'owner') {
      return <Redirect to={`/project/${this.props.project.id}/products`} />
    }
    const header = (
      <div className="flex items-center p-8 md:p-24">
        <img
          style={{
            width: '50px',
          }}
          className="text-32 mr-12"
          alt=""
          src="./assets/images/deeple/7_setting_white.png"
        />
        <Typography variant="title">Settings</Typography>
      </div>
    )

    const content = (
      <div style={{padding: 24}}>
        {FACEBOOK_ENABLE && (
          <Card style={{padding: '20px', marginBottom: '20px'}}>
            <Typography variant="title">Facebook page connect</Typography>
            <Query
              query={GET_PROJECT}
              variables={{projectId: _.get(this.props, 'project.projectId')}}
            >
              {queryObject => {
                const {refetch} = queryObject
                if (queryObject.loading) return 'Loading'
                if (queryObject.error) return 'Error'
                const {
                  getProject: {
                    facebookPageId,
                    facebookPageToken,
                    facebookPageName,
                  },
                } = queryObject.data
                if (facebookPageId && facebookPageToken && facebookPageName) {
                  return (
                    <Mutation mutation={DISCONNECT_TO_FACEBOOK_PAGE}>
                      {(disconnectFacebook, resultObj) => {
                        if (resultObj.loading) return 'Loading'
                        return (
                          <div>
                            <Button
                              style={{marginTop: '12px'}}
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                this.handleDeepleFacebookDisconnect(
                                  disconnectFacebook,
                                  refetch,
                                )
                              }
                            >
                              Disconnect "{facebookPageName}" from Deeple
                            </Button>
                          </div>
                        )
                      }}
                    </Mutation>
                  )
                }
                return (
                  <div>
                    {!this.state.pages && (
                      <Button
                        style={{marginTop: '12px'}}
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          this.handleDeepleFacebookConnect(refetch)
                        }
                      >
                        Deeple Connect
                      </Button>
                    )}
                    {this.state.pages && (
                      <div>
                        <FormLabel component="legend">Pages</FormLabel>
                        <RadioGroup
                          aria-label="Pages"
                          name="pages"
                          value={this.state.selectedPageValue}
                          onChange={this.handlePageRadioChange}
                        >
                          {this.state.pages.data.map((page, index) => (
                            <FormControlLabel
                              key={page.id}
                              value={index.toString()}
                              control={<Radio />}
                              label={page.name}
                            />
                          ))}
                        </RadioGroup>
                        <Mutation mutation={CONNECT_TO_FACEBOOK_PAGE}>
                          {(connectFacebook, {loading, error}) => {
                            if (loading) return 'loading'
                            if (error) return 'error'
                            return (
                              <Button
                                variant="raised"
                                color="primary"
                                className="w-224 mt-16"
                                aria-label="LOG IN"
                                onClick={() =>
                                  this.onPageConnect(connectFacebook, refetch)
                                }
                              >
                                Connect
                              </Button>
                            )
                          }}
                        </Mutation>
                      </div>
                    )}
                  </div>
                )
              }}
            </Query>
          </Card>
        )}
        <Card
          style={{padding: '20px', display: 'flex', flexDirection: 'column'}}
        >
          <Typography variant="title">
            LINE@ Connect{' '}
            {this.state.webhookURL && `(${this.state.webhookURL})`}
          </Typography>
          <TextField
            disabled={this.state.isLineCredentialSubmitted}
            onChange={this.handleLineChannelIdInputChange}
            value={this.state.lineChannelId}
            label="Channel ID"
          />
          <TextField
            disabled={this.state.isLineCredentialSubmitted}
            onChange={this.handleLineChannelSecretInputChange}
            value={this.state.lineChannelSecret}
            label="Channel Secret"
          />
          <TextField
            disabled={this.state.isLineCredentialSubmitted}
            onChange={this.handleLineChannelAccessTokenInputChange}
            value={this.state.lineChannelAccessToken}
            multiline
            label="Channel Access Token"
          />
          {!this.state.isLineCredentialSubmitted && (
            <Button
              style={{
                marginTop: '12px',
                background: '#663EE8',
                color: '#F9FDFF',
              }}
              disabled={this.state.isLineCredentialSubmitting}
              variant="contained"
              onClick={this.handleDeepleLineConnect}
            >
              Save
            </Button>
          )}
          {this.state.isLineCredentialSubmitted && !this.state.editing && (
            <Button
              style={{marginTop: '12px', background: '#663EE8'}}
              variant="contained"
              color="primary"
              onClick={this.handleEditClick}
            >
              Edit
            </Button>
          )}
        </Card>
        <ProjectMemberPage
          style={{padding: '20px 0'}}
          project={this.props.project}
        />
      </div>
    )

    return <FusePageCarded header={header} content={content} />
  }
}

export default requireAuthAndProject(SettingsPage)



// WEBPACK FOOTER //
// ./src/main/content/project/settings/Settings.js